import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/lib/i18n";
import { SiteProvider } from "@/lib/site";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { Loader } from "@/components/site/Loader";
import { CookieBanner } from "@/components/site/CookieBanner";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import Home from "@/pages/Home";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import Destinations from "@/pages/Destinations";
import { About, Contact, Legal, Partner } from "@/pages/Static";
import { WaFloat } from "@/components/site/WhatsApp";
import Admin from "@/pages/admin/Admin";
import Blog, { BlogPost } from "@/pages/Blog";

const Shell = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return <Admin />;
  return (
    <>
      <Loader />
      <SmoothScroll />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/nehnutelnosti" element={<Properties />} />
        <Route path="/nehnutelnosti/:slug" element={<PropertyDetail />} />
        <Route path="/destinacie" element={<Destinations />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/spolupraca" element={<Partner />} />
        <Route path="/o-nas" element={<About />} />
        <Route path="/kontakt" element={<Contact />} />
        <Route path="/obchodne-podmienky" element={<Legal kind="terms" />} />
        <Route path="/gdpr" element={<Legal kind="gdpr" />} />
        <Route path="/cookies" element={<Legal kind="cookies" />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
      <CookieBanner />
      <WaFloat />
    </>
  );
};

export default function App() {
  return (
    <HelmetProvider>
      <LangProvider>
        <SiteProvider>
          <BrowserRouter>
            <Shell />
          </BrowserRouter>
          <Toaster position="top-right" />
        </SiteProvider>
      </LangProvider>
    </HelmetProvider>
  );
}
